// Global Instructions Rule Applied!
//
// One cfg.pipeline_statuses row as it rides in the global-configs payload,
// carrying its BEHAVIOUR — is_terminal (has the process ended?) and outcome_id
// (what does it end as?). Those two are independent: a non-terminal status
// still names the outcome it resolves to when the fund closes under it.
//
// Served top-level as well as through the synthesised lookup groups, because a
// lookup detail has nowhere to carry either flag — and a caller asking "which
// status means they invested?" needs exactly those. Bulk Add Prospects used to
// answer that by matching the machine key 'fundraising_status_060'.
//
// Distinct from pipeline_statuses_config_model.ts, which is the Configuration
// grid's row shape (admin CRUD). This is the read-only global-config shape.
//
// MUST stay in lockstep with the Python twin in
// backend/src/data_manager/data_models/global_config_record.py and with
// get_global_configs_v3 — both records are .strict().
import { z } from 'zod'

export const PipelineStatusConfigModelSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    pipeline_type_id: z.string(),
    pipeline_type_key: z.string(),
    is_terminal: z.boolean(),
    outcome_id: z.string().nullish(),
    outcome_key: z.string().nullish(),
    sort_order: z.number().nullish()
  })
  .strict()

export type PipelineStatusConfigModel = z.infer<
  typeof PipelineStatusConfigModelSchema
>
